"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TileLoader_1 = require("../TileLoader");
var axios_1 = require("axios");
var VariantTileLoader = /** @class */ (function (_super) {
    __extends(VariantTileLoader, _super);
    function VariantTileLoader(dataSource, model, contig) {
        var _this = _super.call(this, 1 << 15, // tile size
        1) || this;
        _this.dataSource = dataSource;
        _this.model = model;
        _this.contig = contig;
        return _this;
    }
    VariantTileLoader.cacheKey = function (model) {
        return JSON.stringify(model.query);
    };
    VariantTileLoader.getAvailableContigs = function (model) {
        var contigs = new Array();
        if (model.path != null) {
            return axios_1.default.get(model.path + '/manifest.json')
                .then(function (response) {
                // create a manifest that lists the available contigs
                contigs = contigs.concat(response.data.contigs);
            })
                .catch(function (reason) {
                console.error("Error loading manifest: " + reason);
            }).then(function (_) { return contigs; });
        }
        return Promise.resolve(contigs);
    };
    VariantTileLoader.prototype.mapLodLevel = function (l) {
        if (this.model.query == null) {
            return 0;
        }
        return Math.floor(l / 10) * 10;
    };
    VariantTileLoader.prototype.getTilePayload = function (tile) {
        if (this.model.path != null) {
            // vvariants-dir json file load
            var jsonPath = this.model.path + "/" + this.contig + "/" + tile.x + "," + tile.span + ".json";
            return axios_1.default.get(jsonPath).then(function (a) {
                return a.data;
            });
        }
        return [];
    };
    return VariantTileLoader;
}(TileLoader_1.TileLoader));
exports.VariantTileLoader = VariantTileLoader;
exports.default = VariantTileLoader;
